import { DataTexture, Group, Mesh } from "three";
import { SharpiePack } from './sharpiePack';
import Lights from "../lights";
import { Pages } from "./pages";
import { checkIfSkipButtonPressed } from "../../../dom/pages/Prompt";
import { hideGyroPrompt, hideIntro, hideIntroFooter, hideLookAroundPrompt, hidePrompt, revealGyroPrompt, revealIntro, revealIntro1, revealIntro2, revealLookAroundPrompt } from "../../../dom";
import { awaitTimer } from "../../utils";
import { LoadedGLTFs } from "../../utils/types";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import { Params } from "../../../utils/types";

export default class Intro {
    public instance: Group;
    private sharpiePack: SharpiePack;
    private pages: Pages;
    private introStarted: boolean;
    private introComplete: boolean;
    private lights: Lights;
    private isTracking: boolean;
    private phoneDown: boolean;


    constructor(gltfs: LoadedGLTFs, envMap: DataTexture, urlParams: Params, lights: Lights) {
        this.instance = new Group();
        this.introStarted = false;
        this.sharpiePack = new SharpiePack(gltfs, envMap, urlParams);
        this.pages = new Pages(gltfs, urlParams);
        this.lights = lights;
        this.introComplete = false;
        this.isTracking = false;
        this.phoneDown = false;

        this._addToIntro(lights.instance)
        this._addToIntro(this.sharpiePack.instance)
        this._addToIntro(this.pages.instance)
    }


    start = () => {
        return new Promise<void>((resolve, reject) => {
            checkIfSkipButtonPressed().then(() => {
                hideIntroFooter();
                hidePrompt();//temp
                resolve();
            })
        })
    }

    playIntro = () => {
        return new Promise<void>((resolve, reject) => {
            if (this.introStarted) {
                reject()
            }
            else {
                this.introStarted = true;
                hidePrompt();
                revealIntro();
                this.updatePrompt();
                this.sharpiePack.playAnimation()
                    .then(() => {
                        this.sharpiePack.hidePensAndPlastic();
                        //this.lights.turnDownLights()
                        this.pages.fadeInAnimation()
                            .then(() => {
                                this.sharpiePack.hide();
                                awaitTimer(4000).then(revealIntro1)
                                this.pages.playWhitePaperAnimation()
                                    .then(() => {
                                        awaitTimer(500).then(revealIntro2)
                                        this.pages.playBlackPaperAnimation()
                                            .then(this.pages.fadeOutAnimation)

                                            .then(() => {
                                                revealLookAroundPrompt()
                                                awaitTimer(4000)
                                                    .then(() => {
                                                        hideLookAroundPrompt()
                                                            .then(() => {
                                                                hideGyroPrompt();
                                                                this.introComplete = true;
                                                                hideIntro();
                                                                resolve();
                                                            })
                                                    })

                                            })
                                    })
                            })
                    })
            }

        })

    }

    _addToIntro = (object: Mesh | Group) =>
        this.instance.add(object)


    update = (deltaTime: number) => {
        this.sharpiePack?.update(deltaTime);
        this.pages?.update(deltaTime);
    };

    public toggleTracking(isTracking: boolean) {
        this.isTracking = isTracking;
        let waitTime = isTracking ? 0 : 1000
        awaitTimer(waitTime).then(() => {
            this.updatePrompt()
        })

    }

    public updatePhoneDirection = (phoneDown: boolean) => {
        this.phoneDown = phoneDown;
        this.updatePrompt()
    }

    private updatePrompt() {
        if (!this.introComplete) {
            if (!this.isTracking && this.phoneDown) {
                hideIntro();
                revealGyroPrompt();
            }
            else {
                hideGyroPrompt();
                revealIntro();
            }
        }
    }
}